import script from "./GateMixin.vue?vue&type=script&lang=js"
export * from "./GateMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__